'use strict';

export default function() {
  return {
    controller: function($scope, $uibModal) {
      'ngInject';

      $scope.AddGroup = function AddGroup() {
        if(!$scope.element.data) {
          $scope.element.data = {};
        }
        if(!$scope.element.data.groups) {
          $scope.element.data.groups = [];
        }
        $scope.element.data.groups.push({
          name: 'New Group',
          items: []
        });
      };

      $scope.MoveGroup = function MoveGroup(index, change) {
        var tab = $scope.element.data.groups.splice(index, 1)[0];
        $scope.element.data.groups.splice(index + change, 0, tab);
      };

      $scope.RemoveGroup = function RemoveGroup(index) {
        var group = $scope.element.data.groups[index];
        if(confirm(`Are you sure you want to delete the group ${group.name}?`)) {
          $scope.element.data.groups.splice(index, 1);
        }
      };

      $scope.EditGroup = function EditGroup(group) {
        $uibModal.open({
          templateUrl: 'ProgramsBoxesEditGroup',
          size: 'xlg',
          scope: $scope,
          controller: function($scope, $uibModalInstance) {
            $scope.group = group;
            $scope.AddItem = function AddItem() {
              $scope.group.items.push({
                name: "New Item"
              });
            };
            $scope.MoveItem = function MoveItem(index, change) {
              var tab = $scope.group.items.splice(index, 1)[0];
              $scope.group.items.splice(index + change, 0, tab);
            };

            $scope.RemoveItem = function RemoveItem(index) {
              var group = $scope.group.items[index];
              if(confirm(`Are you sure you want to delete the item ${group.name}?`)) {
                $scope.group.items.splice(index, 1);
              }
            };

          }
        });
      };


    },
    template: require('./eventCallToAction.html'),
    scope: {
      pageid: "=",
      element: "="
    }
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/properties/eventcalltoaction.js